import { render } from "./Tosola.vue?vue&type=template&id=07810dd2&scoped=true"
import script from "./Tosola.vue?vue&type=script&lang=js"
export * from "./Tosola.vue?vue&type=script&lang=js"

import "./Tosola.vue?vue&type=style&index=0&id=07810dd2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07810dd2"]])

export default __exports__